import React from 'react';
import Aboutdtls from '../Components/Aboutdtls';
import DirectorMessage from '../Components/DirectorMessage';
import TeamMember from '../Components/TeamMember';
import VisionMission from '../Components/VisionMission';
import DemoCall from '../Components/DemoCall';
import PageHero from '../Components/PageHero'

function About() {
  return (
    <>
      <div className="row mt-5"></div>

      <PageHero
        title="About Us"
        subtitle="Know more about our company"
      />
      
      <Aboutdtls />

      <div className="row mt-5"></div>

      <VisionMission />

      <div className="row mt-5"></div>

      <DirectorMessage />

      <TeamMember />

      <DemoCall />
    
    </>
  );
}

export default About;